export class DateUtils {
	static nowHuman() {
		const date = new Date();
		const h = `${date.getHours()}`.padStart(2, '0');
		const m = `${date.getMinutes()}`.padStart(2, '0');
		const s = `${date.getSeconds()}`.padStart(2, '0');
		const currentTime = `${h}:${m}:${s}`;
		const formatedTime = `${currentTime} on ${date.toDateString()}`;
		return formatedTime;
	}
}
